import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [

  {
    path: '',
    redirect: '/index'
  },
  {
    path: '/creSIcreate',
    name: 'cresi_card_list',
    meta: { title: '就诊卡' },
    component: () => import('../views/ElectronicHealthCard/creSIcreate.vue')
  },
  {
    path: '/cresi_card_list',
    name: 'cresi_card_list',
    meta: { title: '就诊卡' },
    component: () => import('../views/versionD/patient_card/cresi_card_list.vue')
  },
  {
    path: '/ymz_index',
    name: 'ymz_index',
    meta: { title: '科室选择' },
    component: () => import('../views/querydept/ymz_index.vue')
  },
  {
    path: '/new_pay_list_D',
    name: 'new_pay_list_D',
    meta: { title: '处方缴费' },
    component: () => import('../views/versionD/ODpay/new_pay_list_D')
  },
  {
    path: '/mlcnindex',
    name: 'mlcnindex',
    meta: { title: '检验列表' },
    component: () => import('../views/mlcnindex')
  },
  {
    path: '/healthcarepay',
    name: 'healthcarepay',
    meta: { title: '检验列表' },
    component: () => import('../views/versionD/ODpay/healthcarepay')
  },
  {
    path: '/dyPacsimg_D',
    name: 'dyPacsimg_D',
    meta: { title: '检验列表' },
    component: () => import('../views/versionD/medicalexamination/dyPacsimg_D')
  },
  {
    path: '/dyListimg_D',
    name: 'dyListimg_D',
    meta: { title: '检验列表' },
    component: () => import('../views/versionD/medicalexamination/dyListimg_D')
  },
  {
    path: '/dyLisList_D',
    name: 'dyLisList_D',
    meta: { title: '检验列表' },
    component: () => import('../views/versionD/medicalexamination/dyLisList_D')
  },
  {
    path: '/dyPacsList_D',
    name: 'dyPacsList_D',
    meta: { title: '检验列表' },
    component: () => import('../views/versionD/medicalexamination/dyPacsList_D')
  },
  {
    path: '/testindex',
    name: 'testindex',
    meta: { title: '挂号' },
    component: () => import('../views/testindex.vue')
  },
  {
    path: '/ylzyy_selectuser',
    name: 'ylzyy_selectuser',
    meta: { title: '挂号' },
    component: () => import('../views/ylxzyyyreg/selectuser.vue')
  },
  {
    path: '/ylzyy_reg_detail',
    name: 'ylzyy_reg_detail',
    meta: { title: '挂号' },
    component: () => import('../views/ylxzyyyreg/reg_detail.vue')
  },
  {
    path: '/ylzyy_scheduldetail',
    name: 'ylzyy_scheduldetail',
    meta: { title: '医生信息' },
    component: () => import('../views/ylxzyyyreg/scheduldetail.vue')
  },
  {
    path: '/ylzyy_index',
    name: 'ylzyy_index',
    meta: { title: '科室列表' },
    component: () => import('../views/ylxzyyyreg/index.vue')
  },
  {
    path: '/ylzyy_docdetail',
    name: 'ylzyy_docdetail',
    meta: { title: '医生信息' },
    component: () => import('../views/ylxzyyyreg/docdetail.vue')
  },
     // 体检报告
     {
      path: '/pereportdetail',
      name: 'pereportdetail',
      meta: { title: '体检报告记录' },
      component: () => import('../views/versionC/pereport/detail.vue')
    },
   // 体检报告列表
   {
    path: '/pereport',
    name: 'pereport',
    meta: { title: '体检报告记录' },
    component: () => import('../views/versionC/pereport/index.vue')
  },
    ///D版电子健康卡绑卡页
    {
      path: '/personalcreateD',
      name: 'personalcreateD',
      meta: { title: '健康卡列表' }, 
      component: () => import('../views/ElectronicHealthCardD/personalcreate.vue')
    },
  ///D版电子健康卡 列表
  {
    path: '/HealthcardListD',
    name: 'HealthcardListD',
    meta: { title: '健康卡列表' }, 
    component: () => import('../views/ElectronicHealthCardD/HealthcardList.vue')
  },
   //电子健康卡详情页
   {
    path: '/personalcreate',
    name: 'personalcreate',
    meta: { title: '就诊卡绑卡' },
    component: () => import('../views/ElectronicHealthCard/personalcreate.vue')
  },
  //电子健康卡详情页
  {
    path: '/CardInformation',
    name: 'CardInformation',
    meta: { title: '就诊卡绑卡' },
    component: () => import('../views/ElectronicHealthCard/CardInformation.vue')
  },
   //D版电子健康卡详情页
   {
    path: '/CardInformationD',
    name: 'CardInformationD',
    meta: { title: '就诊卡绑卡' },
    component: () => import('../views/ElectronicHealthCardD/CardInformation.vue')
  },
    // D版修改病人信息
    {
      path: '/patient_card_modification_D',
      name: 'patient_card_modification_D',
      meta: { title: '就诊卡绑卡' },
      component: () => import('../views/versionD/patient_card/patient_card_modification.vue')
    },
  
  {
    path: '/symptomlist',
    name: 'symptomlist',
    meta: { title: '智能导诊' }, 
    component: () => import('../views/Guidance/symptomlist.vue')
  },
    // 部位选择
    {
      path: '/choose',
      name: 'choose',
      meta: { title: '智能导诊' }, 
      component: () => import('../views/Guidance/choose.vue')
    },
  // 电子健康卡列表
  {
    path: '/payRank',
    name: 'payRank',
    meta: { title: '充 值 记 录' }, 
    component: () => import('../views/AdvancePaymentForHospitalization/payRank.vue')
  },
  //住院预计金住院记录页
    //C版住院费用页
    {
      path: '/prehistorylist',
      name: 'prehistorylist',
      meta: { title: '住院清单' },
      component: () => import('../views/AdvancePaymentForHospitalization/prehistorylist.vue')
    },
  {
    path: '/pay',
    name: 'pay',
    meta: { title: '充 值' }, 
    component: () => import('../views/AdvancePaymentForHospitalization/pay.vue')
  },
  {
    path: '/HealthcardList',
    name: 'HealthcardList',
    meta: { title: '健康卡列表' }, 
    component: () => import('../views/ElectronicHealthCard/HealthcardList.vue')
  },
  {
    path: '/personal',
    name: 'personal',
    meta: { title: '注册列表' }, 
    component: () => import('../views/ElectronicHealthCard/personal.vue')
  },
  {
    path: '/personal2',
    name: 'personal2',
    meta: { title: '输入手机号码' }, 
    component: () => import('../views/ElectronicHealthCard/personal2.vue')
  },
  //医生端查看量表用户列表
  {
    path: '/userlist',
    name: 'userlist',
    meta: { title: '量表列表' }, 
    component: () => import('../views/versionC/doctor/userlist.vue')
  },
  //医生端查看量表结果
  {
    path: '/surveylist',
    name: 'surveylist',
    meta: { title: '量表列表' }, 
    component: () => import('../views/versionC/doctor/surveylist.vue')
  },
   //使用qrcode查询答案
   {
    path: '/qrgaugeresult',
    name: 'qrgaugeresult',
    meta: { title: '量表列表' }, 
    component: () => import('../views/versionC/gaugelist/qrgaugeresult.vue')
  },
    //使用问卷单位ID查询题目
    {
      path: '/qrgaugesubject',
      name: 'qrgaugesubject',
      meta: { title: '量表列表' }, 
      component: () => import('../views/versionC/gaugelist/qrgaugesubject.vue')
    },
  //使用问卷单位ID查询题目
  {
    path: '/qrgaugelist',
    name: 'qrgaugelist',
    meta: { title: '量表列表' }, 
    component: () => import('../views/versionC/gaugelist/qrgaugelist.vue')
  },
   //二维码进入绑卡页面
   {
    path: '/gauegeband',
    name: 'migauegebandd',
    meta: { title: '量表列表' }, 
    component: () => import('../views/versionC/gaugelist/gauegeband.vue')
  },
  //二维码进入后 判断逻辑
  {
    path: '/mid',
    name: 'mid',
    meta: { title: '量表列表' }, 
    component: () => import('../views/versionC/gaugelist/mid.vue')
  },
  //量表用
  {
    path: '/patient_card_createtext',
    name: 'patient_card_createtext',
    meta: { title: '量表列表' }, 
    component: () => import('../views/versionC/gaugelist/patient_card_createtext.vue')
  },
  {
    path: '/testqrcode',
    name: 'testqrcode',
    meta: { title: '量表列表' }, 
 component: () => import('../views/versionC/gaugelist/test.vue')
  },
  {
    path: '/healthcard',
    name: 'healthcard',
    meta: { title: '量表列表' },
    component: () => import('../views/Healthcard/index.vue')
  },
  {
    path: '/testlist',
    name: 'testlist',
    meta: { title: '量表列表' },
    component: () => import('../views/versionC/testODpay/ODpay_list.vue')
  },
  {
    path: '/testdetail',
    name: 'testdetail',
    meta: { title: '量表列表' },
    component: () => import('../views/versionC/testODpay/ODpay_order_detail.vue')
  },
  {
    path: '/reghistory',
    name: 'reghistory',
    meta: { title: '量表列表' },
    component: () => import('../views/versionC/gaugelist/reghistory.vue')
  },
  {
    path: '/gaugeresult',
    name: 'gaugeresult',
    meta: { title: '量表列表' },
    component: () => import('../views/versionC/gaugelist/gaugeresult.vue')
  },
  //题目列表
  {
    path: '/gaugesubject',
    name: 'gaugesubject',
    meta: { title: '量表列表' },
    component: () => import('../views/versionC/gaugelist/gaugesubject.vue')
  },
  //量表列表
  {
    path: '/gaugelist',
    name: 'gaugelist',
    meta: { title: '量表列表' },
    component: () => import('../views/versionC/gaugelist/gaugelist.vue')
  },
  {
    path: '/Queuing',
    name: 'Queuing',
    meta: { title: '排队叫号' },
    component: () => import('../views/versionC/Queuing/index.vue')
  },
  //元马卫生院商城

  {
    path: '/Productlist',
    name: 'Productlist',
    meta: { title: '元马卫生院商城' },
    component: () => import('../views/versionD/Productlist/index.vue')
  },
  {
    path: '/acidtest_detail',
    name: 'acidtest_detail',
    meta: { title: '核酸检测-详情' },
    component: () => import('../views/versionC/acidtest/detail.vue')
  },
  //D版核酸检测
  {
    path: '/acidtest_D',
    name: 'acidtest_D',
    meta: { title: '核酸检测-首页' },
    component: () => import('../views/versionD/acidtest/index.vue')
  },
  //D版抗原
  {
    path: '/DoAgT',
    name: 'DoAgT',
    meta: { title: '核酸检测-首页' },
    component: () => import('../views/versionD/acidtest/DoAgT.vue')
  },
  //核酸检测
  {
    path: '/acidtest',
    name: 'acidtest',
    meta: { title: '核酸检测-首页' },
    component: () => import('../views/versionC/acidtest/index.vue')
  },
  {
    path: '/thirdindex',
    name: 'thirdindex',
    meta: { title: '核酸检测-首页' },
    component: () => import('../views/versionC/acidtest/thirdindex.vue')
  },
  {
    path: '/thirddetail',
    name: 'thirddetail',
    meta: { title: '核酸检测-首页' },
    component: () => import('../views/versionC/acidtest/thirddetail.vue')
  },
  {
    path: '/secondindex',
    name: 'secondindex',
    meta: { title: '核酸检测-首页' },
    component: () => import('../views/versionC/acidtest/secondindex.vue')
  },
 
  {
    path: '/seconddetail',
    name: 'seconddetail',
    meta: { title: '核酸检测-首页' },
    component: () => import('../views/versionC/acidtest/seconddetail.vue')
  },
  {
    path: '/checkedReportDetail',
    name: 'Navigation_a',
    meta: { title: '医院微站-首页' },
    component: () => import('../views/testpdf/checkedReportDetail.vue')
  },
  {
    path: '/examineReportDetail',
    name: 'Navigation_b',
    meta: { title: '医院微站-首页' },
    component: () => import('../views/testpdf/examineReportDetail.vue')
  },
  //医院导航
  {
    path: '/Navigation',
    name: 'Navigation',
    meta: { title: '医院微站-首页' },
    component: () => import('../views/Navigation/index.vue')
  },
  //C版PDF页面
  {
    path: '/hospitalization_C_pdf',
    name: 'hospitalization_C_pdf',
    meta: { title: '医院微站-首页' },
    component: () => import('../views/versionC/medicalexamination/hospitalChekedDetail.vue')
  },
  //D版报告单查询
  {
    path: '/reportList_D',
    name: 'reportList_D',
    meta: { title: "报告单查询" },
    component: () => import('../views/versionD/medicalexamination/repot_query.vue')
  },
  //D版检验报告列表（lis）
  {
    path: '/hospitalCheckedReport_D',
    name: 'hospitalCheckedReport_D',
    meta: { title: "报告单查询" },
    component: () => import('../views/versionD/medicalexamination/hospitalCheckedReport.vue')
  },
  //D版检查报告列表（pacs）
  {
    path: '/hospitalExamineReport_D',
    name: 'hospitalExamineReport_D',
    meta: { title: "报告单查询" },
    component: () => import('../views/versionD/medicalexamination/hospitalExamineReport.vue')
  },
  //C版报告单查询
  {
    path: '/reportList',
    name: 'reportList',
    meta: { title: "报告单查询" },
    component: () => import('../views/versionC/medicalexamination/report_query')
  },
  //C版检验报告首页
  {
    path: '/hospitalChecked',
    name: 'hospitalChecked',
    meta: { title: '检验报告' },
    component: () => import('../views/versionC/medicalexamination/hospitalCheckedReport')
  },
  //C版检查报告首页
  {
    path: '/hospitalExamine',
    name: 'hospitalExamine',
    meta: { title: '医院微站-首页' },
    component: () => import('../views/versionC/medicalexamination/hospitalExamineReport')
  },
  //C版体检报告首页
  {
    path: '/peisReport',
    name: 'peisReport',
    meta: { title: '医院微站-首页' },
    component: () => import('../views/versionC/medicalexamination/peisReport')
  },
  //C版检验检查报告详情页
  {
    path: '/hospitalization_C_detail',
    name: 'hospitalization_C_detail',
    meta: { title: '医院微站-首页' },
    component: () => import('../views/versionC/medicalexamination/hospitalChekedDetail.vue')
  },
  //金风检验报告列表
  {
    path: '/jingfengLislist',
    name: 'jingfengLislist',
    meta: { title: '检验报告单列表' },
    component: () => import('../views/versionC/medicalexamination/jingfengLislist.vue')
  },
  //金风检验报告详情
  {
    path: '/jingfengLisdetal',
    name: 'jingfengLisdetal',
    meta: { title: '检验报告单列表' },
    component: () => import('../views/versionC/medicalexamination/jingfengLisdetal.vue')
  },
  //金风检查报告列表
  {
    path: '/jingfengPacslist',
    name: 'jingfengPacslist',
    meta: { title: '检验报告单列表' },
    component: () => import('../views/versionC/medicalexamination/jingfengPacslist.vue')
  },
  //金风检查报告详情
  {
    path: '/jinfengPacsdetal',
    name: 'jinfengPacsdetal',
    meta: { title: '检验报告单详情' },
    component: () => import('../views/versionC/medicalexamination/jinfengPacsdetal.vue')
  },
  //C版检查报告详情页
  {
    path: '/hospitalExamine_C_detail',
    name: 'hospitalization_C',
    meta: { title: '医院微站-首页' },
    component: () => import('../views/versionC/medicalexamination/hospitalExamineDetail.vue')
  },
  //D版住院费用详情页
  {
    path: '/hospitalization_detail_D_a',
    name: 'hospitalization_detail_D_a',
    meta: { title: '医院微站-首页' },
    component: () => import('../views/versionD/hospitalization/detail_a.vue')
  },
  //C版住院费用详情页
  {
    path: '/hospitalization_detail_C_a',
    name: 'hospitalization_detail_C',
    meta: { title: '医院微站-首页' },
    component: () => import('../views/versionC/hospitalization/detail_a.vue')
  },
  //D版住院费用详情页
  {
    path: '/hospitalization_detail_D',
    name: 'hospitalization_detail_D',
    meta: { title: '医院微站-首页' },
    component: () => import('../views/versionD/hospitalization/detail.vue')
  },
  //C版住院费用详情页
  {
    path: '/hospitalization_detail_C',
    name: 'hospitalization_detail_C_a',
    meta: { title: '医院微站-首页' },
    component: () => import('../views/versionC/hospitalization/detail.vue')
  },
  //D版住院费用页
  {
    path: '/hospitalization_D',
    name: 'hospitalization_D_a',
    meta: { title: '医院微站-首页' },
    component: () => import('../views/versionD/hospitalization/index.vue')
  },
  //D版住院列表页
  {
    path: '/hospitalization_D_list',
    name: 'hospitalization_D',
    meta: { title: '医院微站-首页' },
    component: () => import('../views/versionD/hospitalization/list.vue')
  },
  //C版住院费用页
  {
    path: '/hospitalization_C',
    name: 'hospitalization_C_c',
    meta: { title: '住院清单' },
    component: () => import('../views/versionC/hospitalization/index.vue')
  },
  //C版住院费用页
  {
    path: '/hospitalization_C_byNo',
    name: 'hospitalization_C_byNo',
    meta: { title: '住院清单' },
    component: () => import('../views/versionC/hospitalization/indexByNo.vue')
  },
  //不排班C版挂号页

  {
    path: '/no_details',
    name: 'no_details',
    meta: { title: '医院微站-首页' },
    component: () => import('../views/querydept/no_details.vue')
  },
  //智能导诊
  {
    path: '/Guidance',
    name: 'Guidance_a',
    meta: { title: '医院微站-首页' },
    component: () => import('../views/Guidance/index.vue')
  },
  //智能导诊
  {
    path: '/Guidance_a',
    name: 'Guidance',
    meta: { title: '医院微站-首页' },
    component: () => import('../views/Guidance/index_a.vue')
  },
  //科室列表详情页
  {
    path: '/deptlist_detail',
    name: 'deptlist_detail',
    meta: { title: '医院微站-首页' },
    component: () => import('../views/Hospitaltrends/deptlist_detail.vue')
  },
  //患者指南页
  {
    path: '/userguide',
    name: 'userguide',
    meta: { title: '医院微站-首页' },
    component: () => import('../views/userguide/index.vue')
  },
  //新冠肺炎
  {
    path: '/Interrogation',
    name: 'Interrogation',
    meta: { title: '医院微站-首页' },
    component: () => import('../views/Interrogation/index.vue')
  },
  {
    path: '/conversation',
    name: 'conversation',
    meta: { title: '医院微站-首页' },
    component: () => import('../views/conversation/conversation')
  },
  //医院动态页页
  {
    path: '/hosnews',
    name: 'hosnews',
    meta: { title: '医院微站-首页' },
    component: () => import('../views/Hospitaltrends/hosnews')
  },

  //科室列表页
  {
    path: '/departmentdetail',
    name: 'departmentdetail',
    meta: { title: '医院微站-首页' },
    component: () => import('../views/Hospitaltrends/departmentdetail')
  },
  //科室列表页
  {
    path: '/departmentlist',
    name: 'departmentlist',
    meta: { title: '医院微站-首页' },
    component: () => import('../views/Hospitaltrends/departmentlist')
  },
  // 系统首页
  {
    path: '/index',
    name: 'index',
    meta: { title: '医院微站-首页' },
    component: () => import('../views/index')
  },

  {
    path: '/uploader',
    name: 'uploader',
    meta: { title: '医院微站-首页' },
    component: () => import('../views/uploader.vue')
  },
  /**
   * 就诊卡
   */
  //d版选择用户页

  {
    path: '/patient_card_selectuser_querydept',
    name: 'patient_card_selectuser_querydept',
    meta: { title: '就诊卡列表' },
    component: () => import('../views/versionD/patient_card/patient_card_selectuser_querydept.vue')
  },
  {
    path: '/patient_card_selectuser',
    name: 'patient_card_selectuser',
    meta: { title: '就诊卡列表' },
    component: () => import('../views/versionD/patient_card/patient_card_selectuser.vue')
  },
  // d版就诊卡列表
  {
    path: '/patient_card_list_D',
    name: 'patient_card_list_D',
    meta: { title: '就诊卡列表' },
    component: () => import('../views/versionD/patient_card/patient_card_list.vue')
  },
  //D版就诊卡绑卡

  {
    path: '/patient_card_bind_D',
    name: 'patient_card_bind_D',
    meta: { title: '就诊卡绑卡' },
    component: () => import('../views/versionD/patient_card/patient_card_bind.vue')
  },
  //D版就诊卡详情
  {
    path: '/patient_card_details_D',
    name: 'patient_card_details_D',
    meta: { title: '就诊卡绑卡' },
    component: () => import('../views/versionD/patient_card/patient_card_details.vue')
  },
  // //D版就诊卡建档
  {
    path: '/patient_card_create_D',
    name: 'patient_card_create_D',
    meta: { title: '就诊卡建档' },
    component: () => import('../views/versionD/patient_card/patient_card_create.vue')
  },
  {
    path: '/patient_card_confUser_C',
    name: 'patient_card_confUser_C',
    meta: { title: '就诊卡列表' },
    component: () => import('../views/versionC/patient_card/patient_card_confUser.vue')
  },
  // c版就诊卡列表
  {
    path: '/patient_card_list_C',
    name: 'patient_card_list_C',
    meta: { title: '就诊卡列表' },
    component: () => import('../views/versionC/patient_card/patient_card_list.vue')
  },
  //c版就诊卡绑卡

  {
    path: '/patient_card_bind_C',
    name: 'patient_card_bind_C',
    meta: { title: '就诊卡绑卡' },
    component: () => import('../views/versionC/patient_card/patient_card_bind.vue')
  },
  //c版就诊卡详情

  {
    path: '/patient_card_details_C',
    name: 'patient_card_details_C',
    meta: { title: '就诊卡绑卡' },
    component: () => import('../views/versionC/patient_card/patient_card_details.vue')
  },
  // //c版就诊卡建档
  {
    path: '/patient_card_create_C',
    name: 'patient_card_create_C',
    meta: { title: '就诊卡建档' },
    component: () => import('../views/versionC/patient_card/patient_card_create.vue')
  },
  /*
   *C版缴费
   */

  //C版缴费记录
  {
    path: '/ODpay_history_C',
    name: 'ODpay_history_C',
    meta: { title: '缴费记录' },
    component: () => import('../views/versionC/ODpay/ODpay_history.vue')
  },
  //C版缴费详细名
  {
    path: '/ODpay_order_detail_C',
    name: 'ODpay_order_detail_C',
    meta: { title: '费用明细' },
    component: () => import('../views/versionC/ODpay/ODpay_order_detail.vue')
  },
  //C版缴费清单
  {
    path: '/ODpay_list_C',
    name: 'ODpay_list_C',
    meta: { title: '缴费清单' },
    component: () => import('../views/versionC/ODpay/ODpay_list.vue')
  },
  //
  // 门诊查询挂号
  {
    path: '/querydept',
    name: 'querydept',
    meta: {
      keepAlive: true, //该字段表示该页面需要缓存
      isBack: false, //用于判断上一个页面是哪个
      title: '选择门诊科室'
    },
    component: () => import('../views/querydept/index.vue')
  },
  {
    path: '/querydept_C',
    name: 'querydept_C',
    meta: {
      keepAlive: true, //该字段表示该页面需要缓存
      isBack: false, //用于判断上一个页面是哪个
      title: '选择门诊科室'
    },
    component: () => import('../views/querydept/querydept_C.vue')
  },

  {
    path: '/scheduldetail',
    name: 'scheduldetail',
    meta: { title: '门诊详情' },
    component: () => import('../views/querydept/scheduldetail')
  },
  // 体检预约
  // 就诊卡
  {
    path: '/cardList',
    name: 'cardList',
    meta: { title: '就诊卡信息' },
    component: () => import('../views/cardList')
  },
  {
    path: '/Carddetails',
    name: 'Carddetails',
    meta: { title: '就诊卡详情' },
    component: () => import('../views/cardList/Carddetails.vue')
  },
  {
    path: '/bandCard',
    name: 'bandCard',
    meta: { title: '绑定新卡' },
    component: () => import('../views/cardList/bandCard')
  },
  {
    path: '/createClient',
    name: 'createClient',
    meta: { title: '注册就诊卡' },
    component: () => import('../views/cardList/createClient')
  },
  // 费用支付
  {
    path: '/paymentOfFees',
    name: 'paymentOfFees',
    meta: { title: '待缴费清单' },
    component: () => import('../views/paymentOfFees/pay_list')
  },
  //D版缴费列表
  {
    path: '/pay_list_D',
    name: 'pay_list_D',
    meta: { title: '缴费列表' },
    component: () => import('../views/versionD/ODpay/pay_list_D.vue')
  },
  //D费用明细
  {
    path: '/pay_list_D_detail',
    name: 'pay_list_D_detail',
    meta: { title: '缴费明细' },
    component: () => import('../views/versionD/ODpay/pay_list_D_detail')
  },
  //缴费记录D版

  {
    path: '/pay_history_D',
    name: 'pay_history_D',
    meta: { title: '缴费明细' },
    component: () => import('../views/versionD/ODpay/pay_history_D.vue')
  },
  //缴费记录
  {
    path: '/pay_history',
    name: 'TEXT_paymentOfFees',
    meta: { title: '缴费记录' },
    component: () => import('../views/paymentOfFees/pay_history')
  },
  //d版缴费记录详情

  {
    path: '/pay_history_D_detail',
    name: 'pay_history_D_detail',
    meta: { title: '缴费记录' },
    component: () => import('../views/versionD/ODpay/pay_history_D_detail.vue')
  },
  //缴费详情
  {
    path: '/paymentDetail',
    name: 'paymentDetail',
    meta: { title: '缴费详情' },
    component: () => import('../views/paymentOfFees/pay_order_detail.vue')
  },
  //  挂号记录
  {
    path: '/useRcorder',
    name: 'useRcorder',
    meta: { title: '预约挂号记录' },
    component: () => import('../views/registethistory/index.vue')
  },

  {
    path: '/regRcorderDetail',
    name: 'regRcorderDetail',
    meta: { title: '挂号详情' },
    component: () => import('../views/userecorder/regrecordedetail.vue')
  },
  //挂号预约
  {
    path: '/schedulhead',
    name: 'schedulhead',
    meta: { title: '挂号预约' },
    component: () => import('../views/querydept/schedulhead.vue'),
  },
  //新挂号预约
  {
    path: '/newschedulhead',
    name: 'newschedulhead',
    meta: { title: '挂号预约' },
    component: () => import('../views/querydept/newschedulhead.vue'),
  },

  //确认挂号
  {
    path: '/ghdetail',
    name: 'ghdetail',
    meta: { title: '确认信息' },
    component: () => import('../views/querydept/details.vue')
  },

  {
    path: '/details_ymzyy',
    name: 'details_ymzyy',
    meta: { title: '确认信息' },
    component: () => import('../views/querydept/details_ymzyy.vue')
  },
  //就诊人列表
  {
    path: '/confirmuser',
    name: 'confirmuser',
    meta: { title: '就诊人列表' },
    component: () => import('../views/querydept/confirmUser.vue')
  },
  //选择用户页
  {
    path: '/confUser',
    name: 'confUser',
    meta: { title: '选择用户' },
    component: () => import('../views/confUser.vue')
  },
  // 体检预约
  {
    path: '/pelist',
    name: 'pelist',
    meta: { title: '体检预约' },
    component: () => import('../views/peLIst/index.vue')
  },
  //元马镇卫生院挂号记录

  {
    path: '/reghistory_ymzyy',
    name: 'reghistory_ymzyy',
    meta: { title: 'reghistory_ymzyy' },
    component: () => import('../views/registethistory/index_ymzwsy.vue')
  },
  {
    path: '/paydetail',
    name: 'paydetail',
    meta: { title: 'paydetail' },
    component: () => import('../views/pay/paydetail.vue')
  },

  {
    path: '/pe_list_meal',
    name: 'pe_list_meal',
    meta: { title: '体检列表' },
    component: () => import('../views/peLIst/pe_list_meal.vue')
  },

  //体检套餐详情
  {
    path: '/pe_meal_detali',
    name: 'pe_meal_detali',
    meta: { title: '体检列表' },
    component: () => import('../views/peLIst/pe_meal_detali.vue')
  },

  //体检套餐预约记录
  {
    path: '/pe_history_list',
    name: 'pe_history_list',
    meta: { title: '预约体检列表' },
    component: () => import('../views/peLIst/pe_history_list.vue')
  },
  //C版门诊缴费清单
  {
    path: '/outpatientFeeList_C',
    name: 'outpatientFeeList_C',
    meta: { title: '门诊缴费清单' },
    component: () => import('../views/versionC/outpatientFeeList/index.vue')
  },
  // 
  // C版门诊缴费清单详情
  {
    path: '/outpatientFeeList_detail_C',
    name: 'outpatientFeeList_detail_C',
    meta: { title: '门诊缴费清单详情' },
    component: () => import('../views/versionC/outpatientFeeList/detail.vue')
  },
 // 处方开立
 {
  path: '/prescription',
  name: 'prescription',
  meta: { title: '处方开立' },
  component: () => import('../views/versionC/doctor/prescription.vue')
},
 // 患者列表
 {
  path: '/Patientlist',
  name: 'Patientlist',
  meta: { title: '处方开立' },
  component: () => import('../views/versionC/doctor/Patientlist.vue')
},


{
  path: '/department',
  name: 'department',
  meta: { title: '科室选择' },
  component: () => import('../views/reservation/department.vue')
},

{
  path: '/reservationIndex',
  name: 'reservationIndex',
  meta: { title: '大理州人民医院' },
  component: () => import('../views/reservation/reservationIndex.vue')
},

{
  path: '/registration',
  name: 'registration',
  meta: { title: '挂号' },
  component: () => import('../views/reservation/registration.vue')
},
{
  path:'/expenses',
  name:'expenses',
  meta:{title:'住院费用'},
  component:()=>import('../views/versionC/hospitalization/expenses.vue')
},

]
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  // base:'/',
  routes
})
// router.beforeEach((to, from, next) => {
//   document.title = to.path !== '/schedulhead' ? to.meta.title : `${to.query.name}${to.meta.title}`
//   next()
// })
export default router
